import ChipLabel from '/@/components/chip-label';
import Icon from '/@/components/icon';
import { _ } from '/@/locale';

export const getCrops = (
    { size, chipSize }: { size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'; chipSize?: 'xs' | 'sm' | 'md' } = {
        size: 'xxs',
        chipSize: 'sm',
    }
): Record<
    string,
    {
        name: string;
        icon: React.ReactElement;
        color: string;
        order: number;
        value: string;
        getChip: (props: { text: string }) => React.ReactElement;
    }
> => {
    return {
        corn: {
            name: _('Maíz'),
            icon: <Icon padding={false} type='cornNew' size={size} style={{ fill: '#404006' }} />,
            color: '#F2F2B6',
            order: 1,
            value: 'corn',
            getChip: (props: { text: string }) => {
                return (
                    <ChipLabel
                        label={`${_('Maíz')}`}
                        type='corn'
                        size={chipSize}
                        text={props.text}
                        icon={<Icon padding={false} type='cornNew' size='xxs' style={{ fill: '#404006' }} />}
                    />
                );
            },
        },
        soy: {
            name: _('Soja'),
            icon: <Icon padding={false} type='soy2' size={size} style={{ fill: '#053709' }} />,
            color: '#D3FFD7',
            order: 2,
            value: 'soy',
            getChip: (props: { text: string }) => {
                return (
                    <ChipLabel
                        label={`${_('Soja')}`}
                        type='soy'
                        size={chipSize}
                        text={props.text}
                        icon={<Icon padding={false} type='soy2' size='xxs' style={{ fill: '#053709' }} />}
                    />
                );
            },
        },
        wheat: {
            name: _('Trigo'),
            icon: <Icon padding={false} type='wheat' size='xxs' style={{ fill: '#593F09' }} />,
            color: '#FFE6B2',
            order: 3,
            value: 'wheat',
            getChip: (props: { text: string }) => {
                return (
                    <ChipLabel
                        label={`${_('Trigo')}`}
                        type='wheat'
                        size={chipSize}
                        text={props.text}
                        icon={<Icon padding={false} type='wheat' size='xxs' style={{ fill: '#593F09' }} />}
                    />
                );
            },
        },
        barley: {
            name: _('Cebada'),
            icon: <Icon padding={false} type='wheat' size='xxs' style={{ fill: '#593F09' }} />,
            color: '#FFE6B2',
            order: 4,
            value: 'barley',
            getChip: (props: { text: string }) => {
                return (
                    <ChipLabel
                        label={`${_('Cebada')}`}
                        type='barley'
                        size='sm'
                        text={props.text}
                        icon={<Icon padding={false} type='barley' size='xxs' style={{ fill: '#593F09' }} />}
                    />
                );
            },
        },
        fallow: {
            name: _('Barbecho'),
            icon: <Icon padding={false} type='diseaseRecommendation' size={size} style={{ fill: '#10384F' }} />,
            color: '#D5EDFF',
            order: 5,
            value: 'fallow',
            getChip: (props: { text: string }) => {
                return (
                    <ChipLabel
                        label={`${_('Barbecho')}`}
                        type='fallow'
                        size={chipSize}
                        text={props.text}
                        icon={
                            <Icon padding={false} type='diseaseRecommendation' size='xxs' style={{ fill: '#10384F' }} />
                        }
                    />
                );
            },
        },
    };
};

export const getRecommendationTypes = () => {
    return {
        corn: {
            name: _('Híbrido'),
            icon: <Icon padding={false} type='cornNew' size='xxs' theme='dekalb' />,
            color: '#FFC61A',
            order: 1,
        },
        soy: {
            name: _('Soja'),
            icon: <Icon padding={false} type='soy2' size='xxs' theme='cultivio' />,
            color: '#006A28',
            order: 2,
        },
        herbicide: {
            name: _('Herbicida'),
            icon: <Icon padding={false} type='herbicide' size='xxs' />,
            color: '#006A28',
            order: 3,
        },
        fungicide: {
            name: _('Fungicida'),
            icon: <Icon padding={false} type='weedRecommendation' size='xxs' theme='cultivio' />,
            color: '#006A28',
            order: 4,
        },
        insecticide: {
            name: _('Insecticida'),
            icon: <Icon padding={false} type='plagueRecommendation' size='xxs' theme='expertobayer' />,
            color: '#006A28',
            order: 5,
        },
        density: {
            name: _('Densidad'),
            icon: <Icon padding={false} type='cornDensityRecommendation' size='xxs' theme='expertobayer' />,
            color: '#006A28',
            order: 6,
        },
        seed_treatment: {
            name: _('Trat. Semillas'),
            icon: <Icon padding={false} type='seedBag' size='xxs' theme='expertobayer' />,
            color: '#7B4F00',
            order: 7,
        },
    };
};
